module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-card', {
    attrs: {
      "width": "100%",
      "flat": ""
    }
  }, [_c('v-card-text', [_c('v-container', [(_vm.showUpload || !_vm.isEdit) ? _c('v-row', {
    attrs: {
      "align": "start",
      "justify": "left"
    }
  }, [_c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.media.length === 0),
      expression: "media.length === 0 "
    }],
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "4",
      "lg": "4"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "font-size": "14px",
      "font-weight": "400"
    }
  }, [_vm._v("Client Logo")]), _vm._v(" "), _c('v-responsive', {
    attrs: {
      "aspect-ratio": 1
    }
  }, [_c('v-card', {
    staticClass: "d-flex",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "outlined": "",
      "flat": "",
      "rounded": ""
    },
    on: {
      "click": function($event) {
        return _vm.$refs.mediaUpload.click()
      }
    }
  }, [_c('v-btn', {
    staticClass: "ma-auto",
    attrs: {
      "dark": "",
      "icon": "",
      "x-large": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_vm._v("mdi-cloud-upload")])], 1), _vm._v(" "), _c('input', {
    ref: "mediaUpload",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "name": "images",
      "id": "fileToUpload",
      "accept": "image/*"
    },
    on: {
      "change": _vm.prepareUpload
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit),
      expression: "isEdit"
    }],
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.showUpload = false
      }
    }
  }, [_vm._v("\n                  Cancel\n                ")])], 1)], 1), _vm._v(" "), _vm._l((_vm.media), function(img, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6",
        "lg": "6"
      }
    }, [_c('v-hover', {
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var hover = ref.hover;

          return [_c('v-card', {
            staticClass: "mx-auto",
            attrs: {
              "flat": "",
              "elevation": hover ? 16 : 2
            }
          }, [_c('v-img', {
            staticClass: "grey lighten-2",
            attrs: {
              "src": img.preview.thumbnail,
              "lazy-src": img.preview.thumbnail
            }
          })], 1)]
        }
      }], null, true)
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "text-align": "center"
      }
    }, [_c('v-btn', {
      attrs: {
        "dark": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteImage(index)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": "",
        "color": "red"
      }
    }, [_vm._v("cancel")])], 1)], 1)], 1)
  })], 2) : _c('v-row', {
    attrs: {
      "align": "start",
      "justify": "left"
    }
  }, [(_vm.logoURI !== null && _vm.logoURI !== '') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-img', {
    staticClass: "grey lighten-2",
    attrs: {
      "src": _vm.logoURI,
      "lazy-src": _vm.logoURI,
      "cover": ""
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function() {
        return [_c('v-row', {
          staticClass: "fill-height ma-0",
          attrs: {
            "align": "center",
            "justify": "center"
          }
        }, [_c('v-progress-circular', {
          attrs: {
            "indeterminate": "",
            "color": "grey lighten-5"
          }
        })], 1)]
      },
      proxy: true
    }], null, false, 4034393411)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit),
      expression: "isEdit"
    }],
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showUpload = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "info"
    }
  }, [_vm._v("mdi-pencil")])], 1)], 1)], 1) : _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c('v-img', {
    staticClass: "grey lighten-2",
    attrs: {
      "lazy-src": "/static/img/upload-post-photo.png",
      "src": "/static/img/upload-post-photo.png",
      "cover": ""
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit),
      expression: "isEdit"
    }],
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showUpload = true
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "info"
    }
  }, [_vm._v("mdi-pencil")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7aecff34"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload/index.vue
// module id = 2213
// module chunks = 0